module.exports = __webpack_public_path__ + "fonts/fa-regular-400.b0e2db3b.eot";